<template>
<div>

  <div class="manage-bookings-item  grid-cols-[repeat(14,minmax(0,1fr))]  gap-2 lg:grid">
    <img class="manage-bookings-item__image col-span-1 mb-4 lg:my-auto" :src="booking.property.listingMainPhoto" alt="image" />

    <div class="col-span-4 grid grid-cols-12 mb-1 lg:my-auto">
      <div class="col-span-9">
        <h4 class="font-semibold">{{ booking.property.listingAddress }}</h4>
        <span>{{ booking.property.postcode }}, {{ booking.property.location }}</span>
      </div>
      <span class="col-span-3 text-right lg:text-left my-auto">€ {{ (booking.price+'').replace('.', ',') }}</span>
    </div>


    <div class="manage-bookings-item__row col-span-2  lg:justify-start">
      <span class="manage-bookings-item__row-definition">{{locales && locales['property-bookings'] && locales['property-bookings'].candidates}}</span>

      <div class="manage-bookings-item__candidates">
        <div class="relative" v-if="booking.user && booking.user.subscription && booking.user.subscription.tenants && booking.user.subscription.tenants.length > 1" ref="candidatesPopupWrapper">
          <button class="manage-bookings-item__candidates-button hidden lg:block" @click="toggleCandidatesPopup" :class="{'active': isCandidatesPopupOpen}">{{ booking.user.subscription.tenants.length + ' candidates' }}</button>
          <a class="manage-bookings-item__candidates-button block lg:hidden" data-feature="open-modal" :data-target="'candidates-modal' + booking.id">
            {{ booking.user.subscription.tenants.length + ' candidates' }}
          </a>
          <div v-if="isCandidatesPopupOpen" class="manage-bookings-item__candidates-popup">
            <span class="font-bold mb-2 block">{{ booking.user.subscription.tenants.length + ' candidates' + ':' }}</span>
            <ul>
              <li class="manage-bookings-item__candidates-popup-value" v-for="candidate in booking.user.subscription.tenants">
                {{ candidate.fullNameWithTitle }}
              </li>
            </ul>
          </div>
        </div>
        <span v-else>{{ booking.user.fullNameWithTitle }}</span>
      </div>

    </div>


    <div class="manage-bookings-item__row col-span-1">
      <span class="manage-bookings-item__row-definition">{{ locales && locales['peoperty-bookings'] && locales['peoperty-bookings'].period }}</span>

      <div>
        <span>{{ booking.start_date | formatDate2 }}</span>
        <span>{{ booking.end_date | formatDate2 }}</span>
      </div>
    </div>

    <div class="manage-bookings-item__row col-span-2">
      <span class="manage-bookings-item__row-definition">{{ locales && locales['peoperty-bookings'] && locales['peoperty-bookings'].status }}</span>

      <div class="">
        <span v-if="booking.is_approved === null || booking.is_approved == 0" class="status-marker status-marker--orange">
          {{locales && locales.common && locales.common.requested}}
        </span>
        <span v-if="booking.is_approved == 1 && new Date(booking.start_date) > new Date()" class="status-marker status-marker--green">
          {{locales && locales.common && locales.common.upcoming}}
        </span>
        <span v-if="booking.is_approved == 1 && new Date(booking.end_date) < new Date()" class="status-marker status-marker--gray">
          {{locales && locales.common && locales.common.past}}
        </span>
        <span v-else-if="booking.is_approved == -1" class="status-marker status-marker--gray-disabled">
          {{locales && locales.common && locales.common.rejected}}
        </span>
        <span v-else-if="booking.is_approved == -2" class="status-marker status-marker--gray-disabled">
          {{locales && locales.common && locales.common.cancelled}}
        </span>
      </div>
    </div>



    <div class="manage-bookings-item__contacts-block col-span-2">
      <div class="relative" ref="popupWrapperMail">
        <button class="hidden lg:block" @click="toggleMailPopup">
          <span class="icon-mail icon-orange" :class="{'active': isMailPopupOpen}"></span>
        </button>
        <button class="block lg:hidden" data-feature="open-modal" :data-target="'email-modal' + booking.id">
          <span class="icon-mail icon-orange"></span> 
        </button>

        <ul v-if="isMailPopupOpen" class="manage-bookings-item__contacts-popup">
          <template v-if="booking.user && booking.user.subscription && booking.user.subscription.tenants && booking.user.subscription.tenants.length > 1">
            <li data-copied="wrapper" class="manage-bookings-item__contacts-popup-item" v-for="(candidate, i) in booking.user.subscription.tenants" :key="i">
              <p data-copied="value" class="manage-bookings-item__contacts-popup-value">{{ candidate.email }}</p>
              <div class="flex gap-2 items-center">
                <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'mailto:' + candidate.email">
                  <span class="icon-send icon-orange"></span>
                </a>
              </div>
            </li>
          </template>
          <template v-else>
            <li data-copied="wrapper" class="manage-bookings-item__contacts-popup-item">
              <p data-copied="value" class="manage-bookings-item__contacts-popup-value">{{ booking.user.email }}</p>
              <div class="flex gap-2 items-center">
                <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'mailto:' + booking.user.email">
                  <span class="icon-send icon-orange"></span>
                </a>
              </div>
            </li>
          </template>
        </ul>
      </div>

      <div class="relative" ref="popupWrapperPhone">
        <button class="hidden lg:block" @click="togglePhonePopup">
          <span class="icon-phone icon-orange" :class="{'active': isPhonePopupOpen}"></span>
        </button>
        <button class="block lg:hidden" data-feature="open-modal" :data-target="'phone-modal' + booking.id">
            <span class="icon-phone icon-orange"></span>
        </button>

        <ul v-if="isPhonePopupOpen" class="manage-bookings-item__contacts-popup">
          <template v-if="booking.user && booking.user.subscription && booking.user.subscription.tenants && booking.user.subscription.tenants.length > 1">
            <li data-copied="wrapper" class="manage-bookings-item__contacts-popup-item" v-for="(candidate, i) in booking.user.subscription.tenants" :key="i">
              <p data-copied="value" class="manage-bookings-item__contacts-popup-value">{{ candidate.phone_number }}</p>
              <div class="flex gap-2 items-center">
                <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'tel:' + candidate.phone_number">
                  <span class="icon-phone icon-orange"></span>
                </a>
              </div>
            </li>
          </template>
          <template v-else>
            <li data-copied="wrapper" class="manage-bookings-item__contacts-popup-item">
              <p data-copied="value" class="manage-bookings-item__contacts-popup-value">{{ booking.user.phone_number }}</p>
              <div class="flex gap-2 items-center">
                <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'tel:' + booking.user.phone_number">
                  <span class="icon-phone icon-orange"></span>
                </a>
              </div>
            </li>
          </template>
        </ul>
      </div>

      <!-- <div>
        <a :href="'#box-' + booking.id" class="manage-bookings-item__contact-button" :data-rel="'lightcase:myCollection' + booking.id + 'desktop'">
          <span class="icon-eye icon-orange"></span>
        </a>
        <v-lightcase-holder
          :current-document="booking"
          :disable-rotate="true"
          :image-src="booking.document_url" 
          :name="'box-' + booking.id"
        >
        </v-lightcase-holder>
      </div> -->
    </div>

    <div class="manage-bookings-item__buttons-block col-span-2">
      <button v-if="booking.is_approved === null || booking.is_approved == 0" @click="deleteBooking(booking.id)" class="theme-btn theme-btn--small theme-btn--destructive">{{locales && locales['property-bookings'] && locales['property-bookings'].reject}}</button>
      <button v-if="booking.is_approved === null || booking.is_approved == 0" @click="acceptBooking(booking.id)" class="theme-btn theme-btn--small theme-btn--theme">{{locales && locales['property-bookings'] && locales['property-bookings'].approve}}</button>
      <a class="theme-btn theme-btn--small theme-btn--theme" :href="(lang != 'nl' ? '/'+lang : '')+`/bookings/details/${booking.id}`">
        {{locales && locales['property-bookings'] && locales['property-bookings'].view_details}}
        <span class="icon-thin-right"></span>
      </a>
    </div>
  </div>

  <!-- modals -->
  <div class="modal modal--bottom" data-feature="modal" :data-name="'candidates-modal' + booking.id">
    <div class="modal__content" data-feature="modal-active-area">
      <button class="modal__close" data-feature="close-modal" :data-target="'candidates-modal' + booking.id">
        <i class="icon-close"></i>
      </button>
      <h3 class="section-title-sm mb-4">{{locales && locales['property-bookings'] && locales['property-bookings'].candidates}}</h3>
      <ul>
        <template v-if="booking.user && booking.user.subscription && booking.user.subscription.tenants && booking.user.subscription.tenants.length > 1">
          <li data-copied="wrapper" class="manage-bookings-item__modal-item" v-for="(candidate, i) in booking.user.subscription.tenants" :key="i">
            <span data-copied="value">{{ candidate.fullNameWithTitle }}</span>
            <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
          </li>
        </template>
        <template v-else>
          <li data-copied="wrapper" class="manage-bookings-item__modal-item">
            <span data-copied="value">{{ booking.user.fullNameWithTitle }}</span>
            <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
          </li>
        </template>
      </ul>
    </div>
  </div>

  <div class="modal modal--bottom" data-feature="modal" :data-name="'email-modal' + booking.id">
    <div class="modal__content" data-feature="modal-active-area">
      <button class="modal__close" data-feature="close-modal" :data-target="'email-modal' + booking.id">
        <i class="icon-close"></i>
      </button>
      <h3 class="section-title-sm mb-4">{{locales && locales.common && locales.common.email}}</h3>
      <ul>
        <template v-if="booking.user && booking.user.subscription && booking.user.subscription.tenants && booking.user.subscription.tenants.length > 1">
          <li data-copied="wrapper" class="manage-bookings-item__modal-item" v-for="(candidate, i) in booking.user.subscription.tenants" :key="i">
            <span data-copied="value">{{ candidate.email }}</span>

            <div class="flex items-center gap-3">
              <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'mailto:' + candidate.email">
                  <span class="icon-send icon-orange"></span>
                </a>
            </div>
          </li>
        </template>
        <template v-else>
          <li data-copied="wrapper" class="manage-bookings-item__modal-item">
            <span data-copied="value">{{ booking.user.email }}</span>

            <div class="flex items-center gap-3">
              <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'mailto:' + booking.user.email">
                  <span class="icon-send icon-orange"></span>
                </a>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>

  <div class="modal modal--bottom" data-feature="modal" :data-name="'phone-modal' + booking.id">
    <div class="modal__content" data-feature="modal-active-area">
      <button class="modal__close" data-feature="close-modal" :data-target="'phone-modal' + booking.id">
        <i class="icon-close"></i>
      </button>
      <h3 class="section-title-sm mb-4">{{locales && locales.common && locales.common.phone}}</h3>
      <ul>
        <template v-if="booking.user && booking.user.subscription && booking.user.subscription.tenants && booking.user.subscription.tenants.length > 1">
          <li data-copied="wrapper" class="manage-bookings-item__modal-item"  v-for="(candidate, i) in booking.user.subscription.tenants" :key="i">
            <span data-copied="value">{{ candidate.phone_number }}</span>

            <div class="flex items-center gap-3">
              <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'tel:' + candidate.phone_number">
                  <span class="icon-phone icon-orange"></span>
                </a>
            </div>
          </li>
        </template>
        <template v-else>
          <li data-copied="wrapper" class="manage-bookings-item__modal-item">
            <span data-copied="value">{{ booking.user.phone_number }}</span>

            <div class="flex items-center gap-3">
              <span class="icon-copy icon-orange" @click="copyToClipboard"></span>
                <a :href="'tel:' + booking.user.phone_number">
                  <span class="icon-phone icon-orange"></span>
                </a>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>

</div>
</template>

<script>
import sweetalert from "sweetalert";
import { mapGetters } from 'vuex';

export default {
  props: {
    booking: {
      default: {},
      Type: Object,
    },
    token: {
      default: '',
      Type: String,
    },
    lang: {
            default: 'nl',
            Type: String,
    },
  },
  data() {
      return {
        isCandidatesPopupOpen: false,
        isMailPopupOpen: false,
        isPhonePopupOpen: false,
        device: 'desktop',
      };
  },
  computed : {
    ...mapGetters(['locales']),
  },
  methods: {
    toggleCandidatesPopup: function () {
      this.isCandidatesPopupOpen = !this.isCandidatesPopupOpen;
      this.isMailPopupOpen = false;
      this.isPhonePopupOpen = false;
    },
    toggleMailPopup: function () {
      this.isMailPopupOpen = !this.isMailPopupOpen;
      this.isPhonePopupOpen = false;
      this.isCandidatesPopupOpen = false;
    },
    togglePhonePopup: function () {
      this.isPhonePopupOpen = !this.isPhonePopupOpen;
      this.sisCandidatesPopupOpen = false;
      this.isMailPopupOpen = false;
    },
    copyToClipboard: function (event) {
      const copiedEmail = event.target.closest('[data-copied="wrapper"]').querySelector('[data-copied="value"]');
      const copiedValue = copiedEmail.textContent;
      navigator.clipboard.writeText(copiedValue).then(function() {
        copiedEmail.classList.add('highlighted');
        setTimeout(() => copiedEmail.classList.remove('highlighted'), 100);
      })
    },
    
    acceptBooking(id) {
      var that = this;
        $.ajax({
            url: `/api/property-bookings/approve`,
            method: 'post',
            data: {
              token: this.token, 
              booking_id: id,
             },
            success: (response) => {
                sweetalert(that.locales && that.locales['property-bookings'] && that.locales['property-bookings'].booking_approved || 'Booking approved').then(value => {
                    window.location.reload();
                })
            },
            error: () => {
                sweetalert('Oops!', 'Error approving', 'error');
            }
        });
    },
    deleteBooking(id) {
            var that = this;
            if (sweetalert) {
                sweetalert(that.locales && that.locales['property-bookings'] && that.locales['property-bookings'].are_you_sure_you_want_to_reject, {
                    buttons: ['Cancel', 'Ok'],
                }).then(value => {
                  if (value) {
                      // alert('Put here rejecting booking endpoint (BookingItem.vue)');
                        $.ajax({
                            url: `/api/property-bookings/reject/${id}`,
                            method: 'put',
                            success: (response) => {
                                this.sweetalert(that.locales && that.locales['property-bookings'] && that.locales['property-bookings'].booking_rejected || 'Booking rejected').then(value => {
                                    window.location.reload();
                                })
                            },
                            error: () => {
                                this.sweetalert('Oops!', 'Error rejecting', 'error');
                            }
                        });
                    }
                });
            }
        },
    closeAllPopups: function (event) {
      if (this.$refs.popupWrapperMail && !this.$refs.popupWrapperMail.contains(event.target)) {
        this.isMailPopupOpen = false;
      }
      if (this.$refs.popupWrapperPhone && !this.$refs.popupWrapperPhone.contains(event.target)) {
        this.isPhonePopupOpen = false;
      }
      if (this.$refs.candidatesPopupWrapper && !this.$refs.candidatesPopupWrapper.contains(event.target)) {
        this.isCandidatesPopupOpen = false;
      }
    },
    toggleDevice: function (breakpoint) {
      if (breakpoint.matches === true) {
        this.device = 'mobile';
      } else if (breakpoint.matches === false) {
        this.device = 'desktop';
      }
    },
  },
  mounted() {
      window.addEventListener('click', this.closeAllPopups);

      const breakpoint = window.matchMedia("(max-width: 1023px)");
      breakpoint.addEventListener("change", () => {
          this.toggleDevice(breakpoint);
      });
      this.toggleDevice(breakpoint);
    },
  beforeDestroy() {
      window.removeEventListener('click', this.closeAllPopups);
    }
  };
</script>